import * as React from "react";
import { createIcon } from "@chakra-ui/react";

const PlugCable = createIcon({
  path: (
    <path
      d="M0 17V15.2049H8.21078C9.42754 15.2049 10.1653 14.5063 10.1653 13.4777C10.1653 12.4395 9.43713 11.7312 8.21078 11.7312H3.84192C1.49461 11.7312 0 10.2272 0 8.1798C0 6.14212 1.49461 4.65753 3.84192 4.65753H7.98084V4.18208C7.98084 3.21176 8.67066 2.56164 9.67665 2.56164H11.8228C12.3784 2.56164 12.4934 2.48402 12.9054 1.98916C13.9401 0.669521 15.3868 0 16.9677 0H19.2383C19.7653 0 20.1198 0.359018 20.1198 0.873288V2.46461H22.994C23.5593 2.46461 24 2.92066 24 3.48345C24 4.05594 23.5593 4.50228 22.994 4.50228H20.1198V6.65639H22.994C23.5593 6.65639 24 7.10274 24 7.67523C24 8.23801 23.5593 8.69406 22.994 8.69406H20.1198V10.2466C20.1198 10.7705 19.7653 11.1296 19.2383 11.1296H16.9677C15.406 11.1296 13.9497 10.46 12.9054 9.13071C12.4934 8.64555 12.3784 8.56792 11.8228 8.56792H9.67665C8.67066 8.56792 7.98084 7.91781 7.98084 6.94749V6.45263H3.71737C2.5006 6.45263 1.77246 7.15126 1.77246 8.1798C1.77246 9.21804 2.49102 9.93607 3.71737 9.93607H8.09581C10.4335 9.93607 11.9281 11.4304 11.9281 13.4777C11.9281 15.5251 10.4335 17 8.09581 17H0Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 24 17",
});

export { PlugCable };
